module.exports = __webpack_public_path__ + "img/pr-47.d8cecb6a.png";